/**
 * @generated SignedSource<<d245646640978aed7821dc229d7b033e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SessionLimitTypeEnum = "USER" | "ACCOUNT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type contactSessionLimitsRemainingFragment$data = {
  readonly sessionLimits: {
    readonly sessionLimitType: SessionLimitTypeEnum;
    readonly amountRemaining: number;
  } | null;
  readonly " $fragmentType": "contactSessionLimitsRemainingFragment";
};
export type contactSessionLimitsRemainingFragment$key = {
  readonly " $data"?: contactSessionLimitsRemainingFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contactSessionLimitsRemainingFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contactSessionLimitsRemainingFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SessionLimitPayload",
      "kind": "LinkedField",
      "name": "sessionLimits",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sessionLimitType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amountRemaining",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Contact",
  "abstractKey": null
};

(node as any).hash = "58aca48f63e7fc61afc6b4c666a5e139";

export default node;
